
import store from "../store";
import axios from "axios";
import { toast } from 'react-toastify';
import { USERMESSAGE, USERLOGINADDRESS, UserBuyingCities } from "../type";
const URL = window.location.hostname === 'localhost' ? 'http://localhost:8000' : '';

export const SaveUserAccount = (data) => async (dispatch) => {

  if (data) {
    console.log(data, "=====>")

    axios.post(URL + `/user/userAddress`, data).then((res) => {
      if (res) {

        dispatch({
          type: USERMESSAGE,
          payload: res.data
        })
      }
    })

  }
}





export const GetUserAddress = (useraccount) => async (dispatch) => {
  let Address = {
    Address: useraccount
  }
  await axios.post(URL + `/user/loginwithAddress`, Address).then(async (res) => {
    if (res) {
      dispatch({
        type: USERLOGINADDRESS,
        payload: await res.data
      })
    }
  })
}






export const SavebuyCity = (citesStatsData, Aut) => async (dispatch) => {
  console.log(Aut)
  const data = {
    id: Aut.user._id,
    walletAddress: Aut.user.walletAddress,
    countryCode: citesStatsData.countryCode,
    latitude: citesStatsData.latitude,
    longitude: citesStatsData.longitude,
    name: citesStatsData.name,
    stateCode: citesStatsData.stateCode,
    zip: citesStatsData.zip
  }

  axios.post(URL + `/user/buyCity`, data).then((res) => {
    console.log(res)
  })
}


export const UserBuyCities = (Aut) => async (dispatch) => {
  if (Aut.user) {

    axios.post(URL + `/user/getUserBuyCities`, Aut && Aut.user).then((res) => {
      dispatch({
        type: UserBuyingCities,
        payload: res.data
      })
    })
    // .then((res) => {
    //   console.log(res, "data")
    // })
  }
}